import { render, staticRenderFns } from "./MarketplaceLeadsListLite.vue?vue&type=template&id=2d43a84c&scoped=true&"
import script from "./MarketplaceLeadsListLite.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLeadsListLite.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceLeadsListLite.vue?vue&type=style&index=0&id=2d43a84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43a84c",
  null
  
)

export default component.exports